import { FC, useRef, useState, useEffect, useMemo } from 'react'
import { Box, Text, HStack } from '@chakra-ui/react'
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'
import get from 'lodash/get'
import last from 'lodash/last'
// import Attempts from 'shared/components/sections/sectionTestLinkByMeaning/Attempts'

type Props = {
  value: string
  displayValue?: string
  onDragEndResult: (
    value: string,
    droppedValue: string,
    isCorrect: boolean,
    droppedDisplayValue?: string
  ) => void
  droppedValue?: string
  droppedDisplayValue?: string
  isComplete: boolean
}

const DroppableAreaExamination: FC<Props> = ({
  value,
  displayValue,
  onDragEndResult,
  isComplete,
  droppedValue,
  droppedDisplayValue
}) => {
  const ref = useRef(null)
  const [isDraggedOver, setIsDraggedOver] = useState(false)

  // console.log('value: ', value, 'droppedValue', droppedValue)

  useEffect(() => {
    const el = ref.current

    return dropTargetForElements({
      element: el,
      onDragEnter: () => setIsDraggedOver(true),
      onDragLeave: () => setIsDraggedOver(false),
      getData: () => ({ value }),
      onDrop: (args) => {
        console.log('ON DROP:', args)
        // onDragEndResult()
        const droppedValue = get(args.source.data, 'value') as string
        const droppedDisplayVal = get(args.source.data, 'displayValue') as string
        const isCorrect = value === droppedValue
        onDragEndResult(value, droppedValue, isCorrect, droppedDisplayVal)
        setIsDraggedOver(false)
      },
      canDrop: ({ source }) => {
        return !isComplete
      }
    })
  }, [value, isComplete])

  const { bg, color, borderColor } = useMemo(() => {
    const isCorrect = droppedValue === value
    if (isComplete && isCorrect) {
      return {
        bg: 'green.50',
        borderColor: 'green.800',
        color: 'green.800'
      }
    } else if (isComplete && !isCorrect) {
      return {
        bg: 'red.50',
        borderColor: 'red.700',
        color: 'red.700'
      }
    } else if (droppedValue) {
      return {
        bg: 'transparent',
        borderColor: 'wood.700',
        color: 'wood.700'
      }
    } else {
      return {
        bg: 'transparent',
        borderColor: 'black.200',
        color: 'black.200'
      }
    }
  }, [isComplete, value, droppedValue])

  return (
    <HStack
      w='auto'
      justify='flex-start'
      spacing={1}
      mx={1}
      // position={'relative'}
    >
      <HStack
        ref={ref}
        minW={16}
        // w='fit-content'
        px={2}
        h={8}
        bg={isDraggedOver ? 'wood.200' : bg}
        rounded={'4px'}
        borderWidth={1}
        borderColor={borderColor}
        color={color}
        // position={'absolute'}
      >
        <Box>
          <Text whiteSpace={'nowrap'}>{droppedDisplayValue || droppedValue}</Text>
        </Box>
      </HStack>
    </HStack>
  )
}

export default DroppableAreaExamination
